import styled from "styled-components";
import Box from "../../layout/boxes/Box";
import { StyledVrmProps } from "./Vrm.types";

export const StyledVrmBox = styled(Box)`
	display: inline-flex;
	align-items: center;
	position: relative;
	border: 1px solid ${({ theme }) => theme.palette.hexForRole("fg_light_2")};
	box-sizing: border-box;

	${({ size, theme }) => {
		switch (size) {
			case "md": {
				return {
					height: "32px",
					padding: `0 ${theme.space.sm} 0 calc(${theme.space.sm} + ${theme.space.sm})`,
					borderRadius: theme.radii.xs,
				};
			}
			case "lg": {
				return {
					height: "40px",
					padding: `0 ${theme.space.sm} 0 calc(${theme.space.sm} + ${theme.space.md})`,
					borderRadius: theme.radii.xs,
				};
			}
			default: {
				// default is small 'sm'
				return {
					height: "24px",
					padding: `0 ${theme.space.xs} 0 calc(${theme.space.xs} + ${theme.space.xs})`,
					borderRadius: theme.radii.xxs,
				};
			}
		}
	}}
`;

export const StyledVrmLeftBorder = styled(Box)<Pick<StyledVrmProps, "variant">>`
	position: absolute;
	bottom: -1px;
	top: -1px;
	left: -1px;

	background-color: ${({ theme, variant }) =>
		theme.palette.hexForMandatory(
			variant === "electric" ? "semantic_success_400" : "semantic_info_600"
		)};

	${({ size, theme }) => {
		switch (size) {
			case "md": {
				return {
					width: theme.space.sm,
					borderTopLeftRadius: theme.radii.xs,
					borderBottomLeftRadius: theme.radii.xs,
				};
			}
			case "lg": {
				return {
					width: theme.space.md,
					borderTopLeftRadius: theme.radii.xs,
					borderBottomLeftRadius: theme.radii.xs,
				};
			}
			default: {
				// default is small 'sm'
				return {
					width: theme.space.xs,
					borderTopLeftRadius: theme.radii.xxs,
					borderBottomLeftRadius: theme.radii.xxs,
				};
			}
		}
	}}
`;
